import { Routes } from '@angular/router';
import {LoginComponent} from './modules/acesso/login/login.component';
import {AreaLogadaComponent} from './modules/area-logada/area-logada.component';
import {RecuperarAcessoComponent} from './modules/acesso/recuperar-acesso/recuperar-acesso.component';

export const routes: Routes = [

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'area-logada',
    component: AreaLogadaComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/area-logada/area-logada.module')
          .then(m => m.AreaLogadaModule)
      }
    ]
  },
  {
    path: 'recuperar-acesso',
    component: RecuperarAcessoComponent
  },
  {
    path: '**',
    redirectTo: 'login'
  }

];
